import { render, staticRenderFns } from "./TypeFeatureDialog.vue?vue&type=template&id=20bac170&"
import script from "./TypeFeatureDialog.vue?vue&type=script&lang=js&"
export * from "./TypeFeatureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports